export { default } from './ReportContentRowsSettings'
